import { render } from "./QRCodeView.vue?vue&type=template&id=2263288d&scoped=true"
import script from "./QRCodeView.vue?vue&type=script&lang=js"
export * from "./QRCodeView.vue?vue&type=script&lang=js"

import "./QRCodeView.vue?vue&type=style&index=0&id=2263288d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2263288d"]])

export default __exports__